(ns dashboard.views.statistics.view
  (:require [re-frame.core :as rf]
            [dashboard.html :as html]
            [dashboard.subs :as common-subs]
            [dashboard.services.http-config :as http-config]
            [dashboard.notifications :as notifications]))

(defn show-all-clients? [features-enabled]
  (contains? features-enabled :structured-analysis-creation))

(rf/reg-event-fx
  ::get-statistics
  (fn [{:keys [db]} _]
    {:db (assoc-in db [:statistics :loading] true)
     :http-xhrio {:method :get
                  :uri (if (show-all-clients? (get-in db [:user :features_enabled]))
                         "/api/statistics/clients"
                         "/api/statistics/")
                  :response-format http-config/transit-response-format
                  :on-success [::get-statistics-success]
                  :on-failure [::notifications/add {:message "Failed to get statistics"}]}} ))

(rf/reg-event-db
  ::get-statistics-success
  (fn [db [_ statistics]]
    (assoc-in db [:statistics] {:loading false
                                :data statistics})))

(rf/reg-sub
  ::statistics
  (fn [db _]
    (:statistics db)))

(def view-id
  ::statistics)

(def controllers
  [{:start (fn []
             (rf/dispatch [::get-statistics]))}])

(defn StatisticValue [statistic-name statistic-value]
  (if (sequential? statistic-value)
    [:table.table
     [:thead
      [:tr
       (for [{:keys [label]} statistic-value]
         [:td {:key (str statistic-name "label" label)} label])]]
     [:tbody
      [:tr
       (for [{:keys [label value]} statistic-value]
         [:td {:key (str statistic-name "inner-" label)} value])]]]
    statistic-value))

(defn Statistics []
  (let [{:keys [data loading]} @(rf/subscribe [::statistics])]
    (if loading
      [:div.loader]
      [:div
       (if (show-all-clients? @(rf/subscribe [::common-subs/features-enabled]))
        [:table.table.statistics-table
         [:thead
          [:tr
           [:th "Client"]
           [:th {:style {:text-align "right"}} "Statistic"]
           [:th "Value"]]
          (for [[client-name data] (sort-by first data)]
            [:<> {:key client-name}
             [:tr
              [:td [:b client-name]]
              [:td]
              [:td]]
             (for [{statistic-name :name statistic-value :value} data]
               [:tr {:key (keyword "statistic-name" statistic-name)}
                [:td]
                [:td {:style {:text-align "right"}} (html/as-hiccup-with-anchors statistic-name)]
                [:td
                 [StatisticValue statistic-value]]])])]]
        [:table.table
         [:thead
          [:tr
           [:th {:style {:text-align "right"}} "Statistic"]
           [:th "Value"]]
          (for [{statistic-name :name statistic-value :value} data]
            [:tr {:key (str "statistic-name" statistic-name)}
             [:td {:style {:text-align "right"}} (html/as-hiccup-with-anchors statistic-name)]
             [:td
              [StatisticValue statistic-name statistic-value]]])]])])))
